import { FunctionComponent, useState } from 'react'
import { useQuery } from 'react-query'
import HttpClient from 'shared/httpClients/frotista.api'

import {
  Container,
  Header,
  Main,
  Content,
  Action,
  Heading,
  Button,
  CheckBox,
} from './styles'

import Skeleton from 'shared/components/Skeleton'
import { steps } from 'modules/onboarding'

type TProps = {
  setSelectedStep?(step: number): void
}

const api = new HttpClient().api()

const Termos: FunctionComponent<TProps> = ({ setSelectedStep }) => {
  const [termos, setTermos] = useState('')
  const [isChecked, setIsChecked] = useState(false)

  const { isSuccess, isLoading } = useQuery({
    queryKey: ['getTermosUso'],
    queryFn: () =>
      api.get('/termos-uso', {
        params: {
          type: 'html',
        },
      }),
    onSuccess: res => setTermos(res?.data),
  })

  return (
    <Container>
      <Header />
      <Main>
        <Heading variant="h4">termos de uso</Heading>
        {!isSuccess && isLoading && (
          <>
            <Skeleton width="100%" height="400px" />
            <Skeleton width="100%" maxWidth="400px" height="24px" />
          </>
        )}
        {isSuccess && !isLoading && (
          <>
            <Content dangerouslySetInnerHTML={{ __html: termos }} />
            <CheckBox
              label="Li, entendi e estou de acordo com os Termos de Uso"
              checked={isChecked}
              updateChecked={() => setIsChecked(!isChecked)}
            />
          </>
        )}
      </Main>
      <Action>
        <Button
          type="button"
          variant="contained"
          size="lg"
          onClick={() => setSelectedStep(steps.BemVindo)}
        >
          Voltar
        </Button>
        <Button
          type="button"
          variant="contained"
          size="lg"
          disabled={!isChecked}
          onClick={() => setSelectedStep(steps.Cadastro)}
        >
          Próximo
        </Button>
      </Action>
    </Container>
  )
}

export default Termos
